export default __webpack_public_path__ + "static/media/regulatory--roundabout--g3.2d0882dd.png";